import { makeStyles } from '@mui/styles';

const getCellSize = (percentage: number) => {
  return `calc(100% * ${percentage / 100})`;
};

export const useTableRowStyles = makeStyles((theme) => ({
  cell: {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '16px 12px',
  },

  providerIdCell: {
    paddingLeft: '16px',
    minWidth: '110px',
    width: getCellSize(10),
  },

  productTypeCell: {
    minWidth: '110px',
    width: getCellSize(8),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(10),
    },
  },

  defaultRateCell: {
    minWidth: '6px',
    width: getCellSize(8),
  },

  statusCell: {
    minWidth: '120px',
    width: getCellSize(12),
  },

  timeLeftCell: {
    minWidth: '120px',
    width: getCellSize(13),
  },

  dealSizeCell: {
    minWidth: '210px',
    width: getCellSize(14),
  },

  nominalValueCell: {
    minWidth: '130px',
    width: getCellSize(10),
  },

  irrCell: {
    minWidth: '140px',
    width: getCellSize(15),
  },

  percentCell: {
    minWidth: '80px',
    width: '80px',
  },

  dealPriceCell: {
    minWidth: '130px',
    width: getCellSize(12),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(13),
    },
  },

  expirationCell: {
    minWidth: '120px',
    width: getCellSize(10),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(12),
    },
  },

  inputCell: {
    maxWidth: 'calc(50px + 32px)',
    minWidth: 'calc(50px + 32px)',
    width: 'calc(50px + 32px)',
    minHeight: 'calc(34px + 32px)',
    flexShrink: 0,
    paddingLeft: '16px',
    paddingRight: '16px',
  },
}));
